import { AboutUs } from "@/components/aboutUs";
import { IAboutData } from "@/interfaces/IAboutUsData";
import cmsService from "@/libs/services/cmsService";
import { GetServerSideProps } from "next";

type props = {
    aboutData: IAboutData
}
const aboutUs = ({ aboutData }: props) => {
    return <><AboutUs aboutData={aboutData}/></>
}
export const getServerSideProps: GetServerSideProps = async (context) => {
    const aboutDetails = await cmsService.getAboutData()
    const categories = await cmsService.getAllCategories()
    if (!aboutDetails || aboutDetails.length === 0 || !categories || categories.length === 0)
        return {
            notFound: true
        }
    return {
        props: {
            aboutData: {
                aboutDetails: aboutDetails[0],
                categories:categories
            }
        },
    };
};
export default aboutUs;